import { Link } from "react-router-dom";
import type { AnimeArticle } from "@/mocks/animeData";

interface AnimeCardProps {
  article: AnimeArticle;
}

export default function AnimeCard({ article }: AnimeCardProps) {
  return (
    <Link
      to={`/article/${article.slug}`}
      className="group block bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-300 transition-all duration-300 cursor-pointer"
      onClick={() => window.scrollTo({ top: 0, behavior: "instant" })}
    >
      <div className="relative w-full aspect-[4/3] overflow-hidden">
        <img
          src={article.image}
          alt={article.title}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute top-3 left-3">
          <span className="inline-block px-2.5 py-1 text-xs font-medium rounded-full bg-background-50/90 text-foreground-700">
            {article.category}
          </span>
        </div>
        <div className="absolute top-3 right-3">
          <span className="inline-flex items-center justify-center w-10 h-10 rounded-full bg-primary-500 text-background-50 text-sm font-bold font-heading">
            {article.rating}
          </span>
        </div>
      </div>
      <div className="p-4 md:p-5">
        <h3 className="text-base font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors duration-200 line-clamp-2 mb-2 font-heading">
          {article.title}
        </h3>
        <p className="text-sm text-foreground-600 line-clamp-2 leading-relaxed">
          {article.excerpt}
        </p>
        <div className="flex items-center justify-between mt-4 text-xs text-foreground-500">
          <span>{article.author}</span>
          <span>{article.publishDate}</span>
        </div>
      </div>
    </Link>
  );
}